import { schema } from 'normalizr';

export const breadcrumb = new schema.Entity(
  'breadcrumbs',
  {},
  {
    idAttribute: item => item.link || item.name,
    processStrategy: item => ({
      name: item.name,
      link: item.link,
    }),
  }
);

export const breadcrumbs = [breadcrumb];
